import { render, staticRenderFns } from "./returnWriteOff.vue?vue&type=template&id=5ed38add&scoped=true&"
import script from "./returnWriteOff.vue?vue&type=script&lang=ts&"
export * from "./returnWriteOff.vue?vue&type=script&lang=ts&"
import style1 from "./returnWriteOff.vue?vue&type=style&index=1&id=5ed38add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed38add",
  null
  
)

export default component.exports